import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import store from "../../../../../Redux/store";
// import { get_branch_transfer_single_view } from './BranchTransferSlice';
import { IconButton, Skeleton, Tooltip } from "@mui/material";
import { CustomerPaymentFilterAPICall, viewCustomerPaymentListAPICall } from "./customerPaymentAPI";
import { get_customer_payment_row_data_list } from "./customerPaymentSlice";
import CategorySearchandFilter from "../../../../Single Components/CategorySearchandFilter";
import { companyProfileInfoForUser } from "../../../../../API/Settings/Company Settings/companySettingsAPI";
import { viewAllCurrencyUpdated } from "../../../../../API/Settings/Currency/CurrencyAPI";
import { filterObjFromList } from "../../../../../Js/generalFunctions";
import { getCurrentTime } from "../../../../../Js/Date";
import CustomPagination from "../../../../Single Components/CustomPagination";
import axios from "axios";
import { setFilterActive } from "../../../../Single Components/listSlice/filterCategorySlice";
import ReactToPrint from "react-to-print";
import ExcelJS from "exceljs";
import TableListActionButtons from "../../../../Single Components/ActionButtons/TableListActionButtons";
import PrintComponentList from "../../../SalesNew/SalesReport/TableListPrint"

export const CustomerPayments = () => {
  let navigate = useNavigate();

  const { currencyDetails } = useSelector((state) => state.mainDashBoardSlice)
  const [filteredDatas, setFilteredData] = useState({});
  const [symbol, setSymbol] = useState(null);
       const printRef = useRef(); 
  
  const customerPaymentList = useSelector(
    (state) => state.customerPaymentSlice.apiResList
  );

  const [FormDataInfo, setFormDataInfo] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(null);

  const filtereDataOptions = useSelector((state) => state.listCategory);


  const createCustomerPayment = () => {
    navigate("/userdashboard/accounts/customer/payments/create");
  };
  const handleBranchSelect = (selectedBranch) => {
    setSelectedBranch(selectedBranch);

  };
  const handleDataFromChild = (data) => {
    setFormDataInfo(data)
  };
  const handlePageChange = (page) => {

    setCurrentPage(page);
  };

  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = customerPaymentList?.pages;

  useEffect(() => {

    setSymbol(currencyDetails?.symbol || "");
  }, [currencyDetails]);


  useEffect(() => {
    localStorage.removeItem("singleViewById");

    store.dispatch(
      get_customer_payment_row_data_list({
        customerPaymentSingleRowData: undefined,
      })
    );

  }, []);
  const handleFilterChange = (updatedItems) => {
    setFilteredData(updatedItems);
  }
  const formatFilterInfo = (filters) => {
    const parts = [];

    if (filters?.toDate && filters.fromDate) {
      parts.push(`As of ${filters.fromDate} to ${filters?.toDate}`);
    }
    if (filters?.branchList) {
      parts.push(
        `Branch: ${filters?.branchList?.storeCode}-${filters?.branchList?.branchName}`
      );
    }
    if (filters?.location) {
      parts.push(`location: ${filters?.location?.name}`);
    }
    if (filters?.toLocation) {
      parts.push(`To Location: ${filters?.toLocation?.name}`);
    }
    if (filters?.status) {
      parts.push(`status: ${filters?.status}`);
    }
    if (filters?.createdBy) {
      parts.push(`createdBy: ${filters?.createdBy}`);
    }
    return parts; // Return the array directly
  };
  const downloadList = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Payments");
    sheet.properties.defaultRowHeight = 20;

    // Add header section
    const titleRow = sheet.addRow(["Payments"]);
    titleRow.font = { size: 15, bold: true };
    sheet.mergeCells("A1:H1");
    titleRow.getCell(1).alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // Add additional header information
    const filterParts = formatFilterInfo(filteredDatas) || [];

    // Ensure filterParts is an array and iterate over it
    if (Array.isArray(filterParts)) {
      filterParts.forEach((part, index) => {
        const row = sheet.addRow([part]);
        row.font = { size: 11, bold: true };
        sheet.mergeCells(`A${index + 2}:H${index + 2}`);
        row.getCell(1).alignment = { vertical: "middle", horizontal: "center" };
      });
    }

    // Add an empty row between header and table
    sheet.addRow([]);

    // Header row styling
    const headerRow = sheet.addRow([
      "Date",
      "Name",
      "Payment Type",
      "Payment Mode",
      "Customer",
      "Total Amount",
      "Created By",
      "Status",

    ]);
    const headerFill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFedf2f9" }, // Use full hex code with "FF" prefix for better compatibility
    };
    const headerFont = {
      size: 12,
      bold: true,
      color: { argb: "FF000000" }, // White font color
    };

    headerRow.eachCell((cell, colNumber) => {
      cell.fill = headerFill;
      cell.font = headerFont;
      cell.alignment = { vertical: "middle", horizontal: "center" }; // Ensure header text is centered
    });

    sheet.columns = [
      { header: "Date", key: "paymentDate", width: 10 },
      { header: "Name", key: "name", width: 20 },
      { header: "Payment Type", key: "PAYMENTTYPE", width: 25 },
      { header: "Payment Mode", key: "paymentMode", width: 25 },
      { header: "Customer", key: "customer", width: 25 },
      { header: "Total Amount", key: "totalAmount", width: 15 },
      { header: "Created By", key: "createdBy", width: 15 },
      { header: "Payments", key: "status", width: 20 },
    ];

    customerPaymentList?.list?.forEach((item, index) => {
      const row = sheet.addRow({
        paymentDate: item?.paymentDate,
        name: item.name,
        PAYMENTTYPE: item.PAYMENTTYPE,
        paymentMode: item?.paymentMode,
        customer: item?.customer,
        totalAmount: item?.totalAmount,
        createdBy: item?.createdBy,
        status: item?.status,

      });

      const rowFill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" }, // Use full hex code with "FF" prefix for better compatibility
      };

      row.eachCell((cell, colNumber) => {
        cell.fill = rowFill;
        cell.border = {
          //   top: { style: "thin", color: { argb: "FF000000" } },
          //   left: { style: "thin", color: { argb: "FF000000" } },
          bottom: { style: "thin", color: { argb: "FFedf2f9" } },
          //   right: { style: "thin", color: { argb: "FFFFFFFF" } },
        };
        if (colNumber >= 1) {
          // Right align all columns except the first
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "Payments.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  };

  const handleClickRow = (row) => {
    localStorage.setItem("singleViewById", row._id);
    store.dispatch(setFilterActive(window.location.pathname))
    navigate("/userdashboard/accounts/customer/payments/create");
  };
  useEffect(() => {

    if (FormDataInfo.length !== 0) {
      let loadData = window.location.pathname === filtereDataOptions?.filterActive
      !loadData &&
        CustomerPaymentFilterAPICall({
          fromDate: FormDataInfo.fromDate === '' ? '' : `${FormDataInfo.fromDate} 00:00:00`,
          toDate: FormDataInfo.toDate === '' ? '' : `${FormDataInfo.toDate} 23:59:59`,
          branchList: FormDataInfo.branchList,
          type: [1],
          status: FormDataInfo.status,
          search: FormDataInfo.search,
          index: currentPage - 1,
        }, setIsLoading);
    }

  }, [FormDataInfo, currentPage]);


  return (
    <div className="global-page-parent-container updated-global-page-parent-container">
      <div className="justify-space-between list-create-head-bar">
        <h3 >Payments</h3>
        <div className="create-head-buttons-container">
          {/* <TableListActionButtons downloadClick={downloadList} /> */}
          <div className="justify-center" style={{ gap: "10px", width: "70%", justifyContent: "flex-end" }}>
             <PrintComponentList contentRef={printRef} />
             <Tooltip title="Download">
    <span>
        <IconButton
            style={{
                backgroundColor: "#ffd2d2",
                color: "#002995",
                borderRadius: "0",
                height: "38px",
                width: "37px",
            }}
            onClick={downloadList}
        >
            <i className="bi bi-arrow-down-circle"></i>
        </IconButton>
    </span>
</Tooltip>

           </div>
          <CategorySearchandFilter
            statusOptions={['COMPLETED', 'DRAFT', "RETURNED"]}
            onData={handleDataFromChild}
            isStatus={true}
            onBranchSelect={handleBranchSelect}

            onFilterChange={handleFilterChange}
          />

          <button
            onClick={createCustomerPayment}
            className="create-button-blue btn btn-primary"
          >
            Create
          </button>
        </div>
      </div>

      <div className="justify-space-between pagination-container">
        {FormDataInfo?.branchList?.length > 0 && (
          <h3>Branch name:
            {selectedBranch?.storeCode || filtereDataOptions?.filterCategorylist?.branchList?.storeCode}
            -{selectedBranch?.branchName || filtereDataOptions?.filterCategorylist?.branchList?.branchName}</h3>
        )}
        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          setFormDataInfo={setFormDataInfo}
        />
      </div>


      <div className="new-global-table-container updated-table-container"ref={printRef}>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Payment Type</th>
              <th>Payment Mode</th>
              <th>Customer</th>
              <th>Total Amount</th>
              <th>Created By</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              [...Array(10)].map((r, i) => (
                <tr key={i}>
                  <td colSpan={8}>
                    <Skeleton
                      variant="rectangular"
                      animation="wave"
                      width={"100%"}
                      height={40}
                    />
                  </td>
                </tr>
              ))
            ) : customerPaymentList?.list !== undefined &&
              customerPaymentList?.list?.length !== 0 ? (
              customerPaymentList?.list
                ?.slice(0)

                .map((r, i) => (
                  <tr
                    key={i}
                    onClick={() => handleClickRow(r)}
                    style={{ cursor: "pointer" }}
                  >
                    <td>{r?.paymentDate}</td>
                    <td>{r?.name}</td>
                    <td>{r?.PAYMENTTYPE}</td>
                    <td>{r?.paymentMode}</td>
                    <td>{r?.customer}</td>
                    <td>{symbol}&nbsp;{r?.totalAmount}</td>
                    <td>{r?.createdBy}</td>
                    <td className="table-data-box">
                      {r?.status === "POSTED" ? (
                        <span className="post"> POSTED</span>
                      ) : r?.status === "DRAFT" ? (
                        <span className="draft"> DRAFTED</span>
                      ) : r?.status === "RETURNED" ? (
                        <span className='return'> RETURN</span>
                      ) : r?.status === "Reconciled" ? (
                        <span className='reconciled'>Reconciled</span>
                      ) : (
                        "---"
                      )}
                    </td>
                  </tr>
                ))
            ) : (
              <tr>
                <td colSpan={7}>No Data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
